import { Link } from "react-router-dom";
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 pt-16">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-6">
            <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-2">页面未找到</h1>
          <p className="text-sm text-foreground-500 mb-6">您访问的页面不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line"></i> 返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}